import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColppyStockSyncService {
  apiName = 'Default';
  

  syncStockWithColppy = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/colppy-stock-sync/sync-stock-with-colppy',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
